'use client';

import useCountry from './useCountry';

const useShopable = () => {
  const [country] = useCountry();
  return country.shopable;
};

export default useShopable;
